'use client';

import { cn } from '@insta-club/utilities';
import { motion } from 'framer-motion';

export interface Props {
    percentage: number;
    direction?: 'rtl' | 'ltr';
    className?: string;
    barClassName?: string;
    duration?: number;
    spring?: boolean;
}

const ProgressBar: React.FC<Props> = ({
    percentage,
    direction = 'rtl',
    className,
    barClassName,
    duration = 0.4,
    spring = false
}) => {
    return (
        <div dir={direction} className={cn('relative h-1 w-full overflow-hidden rounded-full bg-gray-300', className)}>
            <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${percentage}%` }}
                transition={spring ? { type: 'spring', stiffness: 120, damping: 18 } : { duration, ease: 'easeInOut' }}
                className={cn(
                    'bg-primary-500 h-full',
                    direction === 'rtl' && 'origin-right rounded-l-full',
                    direction === 'ltr' && 'origin-left rounded-r-full',
                    barClassName
                )}
            />
        </div>
    );
};

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;

